<template>
  <div class="col-12 col-md-5 col-xl-12">
    <input-select :fieldData="fieldData" />
  </div>
</template>

<script>
import InputSelect from '../../interactive/InputSelect';

export default {
  components: { InputSelect },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['selectOptions', 'agencyIntegrations', 'selectMeta'],
  data() {
    return {
      fieldData: {
        field_value: '', // Initialized as blank string '' so the watcher won't trigger from undefined to blank string
      },
    };
  },
  computed: {
    fieldName() {
      return this.selectMeta.name;
    },
    fieldLabel() {
      return this.selectMeta.label;
    },
    defaultTextValue() {
      return 'Select one';
    },
  },
  methods: {
    // The InputSelect only accepts the common `fieldData` object. This Carrier Manager flow, though, uses a different object structure.
    setFieldData() {
      this.fieldData = {
        label: this.fieldLabel,
        field_type: 'select',
        field_name: this.fieldName,
        is_required: false,
        field_value: '',
        field_validation_rules: '',
        is_enabled: true,
        visible: true,
        max_length: 50,
        values: [],
      };
    },
  },
  mounted() {
    this.setFieldData();
  },
  watch: {
    // Updates parent property since no two-way binding in Vue and the parent object can't be passed to the this component.
    'fieldData.field_value': function fieldDataFieldValue(newValue) {
      this.agencyIntegrations[this.selectMeta.parentProperty] = newValue; // Updates the appropriate property on the parent
    },
    // Updates select values once the API returns the values
    selectOptions: function selectOptions(newValue) {
      this.fieldData.values = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.input-elements {
  >>> .field-input-text {
    .input-group {
      width: 100% !important;
    }

    label {
      display: none;
    }
  }

  >>> .form-group {
    margin-bottom: 0;
  }

  &.read-only-id label {
    font-weight: normal;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/agencyIntegration/PlatformState.vue?5326ea9a